import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

// Create taskStatus API
const taskStatusAPI = createApi({
    reducerPath: "taskStatusAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) =>({
       // taskStatus Endpoints

       // Query to get all taskStatus list
       getAllTaskStatus: builder.query({
            query: () => ({
                url: `/TaskStatus/GetAllTaskStatus`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllStatusCategories: builder.query({
            query: () => ({
                url: `/TaskStatus/GetAllStatusCategories`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
})

// Extract hooks for easy access to various API requests 
export const{
    useLazyGetAllTaskStatusQuery,
    useLazyGetAllStatusCategoriesQuery
} = taskStatusAPI;

export default taskStatusAPI;